<div class="title-container">
  <h2 mat-dialog-title>
    <span class="discussion-about">{{ 'APPLICATION.DISCUSSION_ABOUT' | translate }}</span>
    {{ data.docName | truncate: 40 : false }}
  </h2>
  <button
    mat-button
    type="button"
    class="close-button-wrapper"
    [attr.aria-label]="'COMMON.ACTION.CLOSE' | translate"
    (click)="closeDialog()">
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>
</div>
<mat-dialog-content class="mat-typography" *ngIf="myself$ | async as myself" #dialogContent>
  <div class="comments-wrapper">
    <ng-container *ngIf="(allComments$ | async)?.length; else noCommentsMessage">
      <div *ngFor="let comment of allComments$ | async; index as commentIndex" class="comment-wrapper">
        <div
          class="comment-content"
          matTooltip="{{ comment.author.name || comment.author.email }}"
          matTooltipClass="chatTooltip"
          matTooltipPosition="left"
          matTooltipShowDelay="450"
          [attr.data-cy]="'message-' + commentIndex"
          [class.author-comments]="comment.author.id === myself.id"
          [class.during-edition]="editingComment?.id === comment.id"
          [class.interlocutor-comments]="comment.author.id !== myself.id"
          [innerHTML]="comment.content | linebreaks"></div>
        <div class="created-at-wrapper">
          <p class="created-at-content" [class.dark]="comment.author.id === myself.id">
            {{ comment.createdAt | date: 'dd-MM-yyyy HH:mm' }}
          </p>
        </div>

        <!-- EDIT & DELETE unavailable for foreigners -->
        <div
          class="actions-wrapper"
          *ngIf="myself.role.key !== ROLES_KEYS.Foreigner && comment.author.id === myself.id">
          <button
            type="button"
            class="comment-action"
            (click)="editComment(comment)"
            [attr.data-cy]="'message-edit-' + commentIndex">
            {{ 'COMMON.ACTION.EDIT' | translate }}
          </button>

          |

          <button
            *ngIf="editingComment?.id === comment.id"
            type="button"
            class="comment-action"
            (click)="cancelEdit()"
            [attr.data-cy]="'message-cancel-edit-' + commentIndex">
            {{ 'DISCUSSION_MODAL.CANCEL-EDITING' | translate }}
          </button>

          <button
            *ngIf="editingComment?.id !== comment.id"
            type="button"
            class="comment-action"
            (click)="removeComment(comment)"
            [attr.data-cy]="'message-remove-' + commentIndex">
            {{ 'COMMON.ACTION.REMOVE' | translate }}
          </button>
        </div>
      </div>
    </ng-container>
    <ng-template #noCommentsMessage>
      <div class="no-messages-info">
        <h2 *ngIf="(loadingComments$ | async) === false">
          {{ 'CHAT.NO_MESSAGES_RELATED_THIS_DOCUMENT' | translate }}
        </h2>
      </div>
    </ng-template>
    <div *ngIf="loadingComments$ | async" class="loading-wrapper" role="status" aria-live="polite">
      <span class="sr-only">
        {{ 'COMMON.LAYOUT.LOADING' | translate }}
      </span>

      <mat-spinner [diameter]="40" [attr.aria-hidden]="true"></mat-spinner>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="chat-message-input-wrapper standard-form-field">
    <mat-form-field class="chat-message-content-input" appearance="outline">
      <textarea
        [appAutoFocus]="deviceInfo.deviceTypeDetected === 'DESKTOP'"
        matInput
        #commentInput
        id="chat-message-input-in-modal"
        #autosize="cdkTextareaAutosize"
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="15"
        autocomplete="off"
        autocapitalize="off"
        [(ngModel)]="newCommentContent"
        (keydown.enter)="$event.preventDefault(); submitComment($event)"
        placeholder="{{ 'CHAT.ENTER_YOUR_MESSAGE' | translate }}"
        maxlength="1500"
        minlength="1"
        required>
      </textarea>
      <div class="mat-error" *ngIf="newCommentContent && !commentContentValid()">
        {{ 'CHAT.FORBIDDEN_CHARACTERS_USED' | translate }}
      </div>
    </mat-form-field>
    <button *ngIf="editingComment?.id" mat-icon-button aria-label="Cancel edit" (click)="cancelEdit()">
      <mat-icon class="cancel-edit-chatMessage-icon">close</mat-icon>
    </button>
    <button
      [disabled]="!newCommentContent || !commentContentValid()"
      mat-icon-button
      color="primary"
      aria-label="Submit"
      (click)="submitComment($event)">
      <mat-icon>send</mat-icon>
    </button>
  </div>
</mat-dialog-actions>
